import i18n from "i18next";

import { HazardIdEnum, LocationRiskAssessment, PageTabs, PolicyDetails } from "../hazardIdEnum";
import { gemSeismicColors, qgis_map_export_58_colors, qgis_map_export_56_colors } from "../../util/colors";
import { PermissionIdEnum } from "../../util/types/permissions/permissionIdEnum";

const seismicColors = [
  "#f9f9f9",
  "#2b83ba",
  "#64abb0",
  "#9dd3a6",
  "#c7e8ad",
  "#ecf7b9",
  "#ffedaa",
  "#fec980",
  "#f99d59",
  "#e85b3b",
  "#d7191c",
];

export const getNatcatHazardsList = (): Hazard[] => [
  {
    cysId: HazardIdEnum.SeismicRiskHowden,
    name: "Seismic Risk Howden",
    // permissions: ["CYS_RISK_SEISMIC_HOWDEN"],
    permissions: [PermissionIdEnum.SeismicRiskHowden],
    colorRange: seismicColors,
    description: i18n.t("riskExposureMapExplained.seismicClassificationHowden"),
    label: `${i18n.t("legend.seismicHowdenRisk")}1`,
    pages: [PolicyDetails, LocationRiskAssessment],
    validityNote: "Mappa valida dal 01/10/2024 al 23/03/2025",
  },
  {
    cysId: HazardIdEnum.SeismicRiskHowden2,
    name: "Seismic Risk Howden2",
    // permissions: ["CYS_RISK_SEISMIC_HOWDEN2"],
    permissions: [PermissionIdEnum.SeismicRiskHowden2],
    colorRange: seismicColors,
    description: i18n.t("riskExposureMapExplained.seismicClassificationHowden2"),
    label: `${i18n.t("legend.seismicHowdenRisk")}2`,
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.preferredTab,
    validityNote: "Mappa valida dal 24/03/2025",
  },
  {
    cysId: HazardIdEnum.InlandFloodHowden,
    name: "Inland Flood Howden",
    // permissions: ["CYS_RISK_INLAND_FLOOD_HOWDEN"],
    permissions: [PermissionIdEnum.InlandFloodHowden],
    colorRange: [
      "#f9f9f9",
      "#2b83ba",
      "#64abb0",
      "#9dd3a6",
      "#c7e8ad",
      "#ecf7b9",
      "#ffedaa",
      "#fec980",
      "#f99d59",
      "#e85b3b",
      "#d7191c",
    ],
    description: i18n.t("riskExposureMapExplained.inlandFloodHowden"),
    label: i18n.t("riskAssessment.inlandFloodHowden"),
    pages: [PolicyDetails, LocationRiskAssessment],
    validityNote: "Mappa valida dal 01/10/2024 al 26/01/2025",
  },
  {
    cysId: HazardIdEnum.InlandFloodHowden58,
    name: "Inland Flood Howden 58",
    // permissions: ["CYS_RISK_INLAND_FLOOD_HOWDEN58"],
    permissions: [PermissionIdEnum.InlandFloodHowden58],
    colorRange: [...qgis_map_export_58_colors].reverse(),
    description: i18n.t("riskExposureMapExplained.inlandFloodHowden58"),
    label: i18n.t("riskAssessment.inlandFloodHowden58"),
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.otherTab,
    validityNote: "Mappa valida dal 27/01/2025 al 19/09/2025",
  },
  {
    cysId: HazardIdEnum.InlandFloodHowden56,
    name: "Inland Flood Howden 56",
    // permissions: ["CYS_RISK_INLAND_FLOOD_HOWDEN56"],
    permissions: [PermissionIdEnum.InlandFloodHowden56],
    colorRange: [...qgis_map_export_56_colors].reverse(),
    description: i18n.t("riskExposureMapExplained.inlandFloodHowden56"),
    label: i18n.t("riskAssessment.inlandFloodHowden56"),
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.preferredTab,
    validityNote: "Mappa valida dal 20/09/2025",
  },
  {
    cysId: HazardIdEnum.LandslideRiskIspra,
    name: "Landslide Ispra",
    // permissions: ["CYS_RISK_LANDSLIDE_HOWDEN"],
    permissions: [PermissionIdEnum.LandslideRiskIspra],
    colorRange: ["#F7F7F7", "#f5cb40", "#e66800", "#feff73", "#e60200", "#730102"],
    description: i18n.t("riskExposureMapExplained.landslideRiskIspra"),
    label: i18n.t("riskAssessment.landslideRiskIspra"),
    pages: [PolicyDetails, LocationRiskAssessment],
    pageTab: PageTabs.preferredTab,
  },
  {
    cysId: HazardIdEnum.InlandFloodIspra,
    name: "Inland Flood Ispra",
    // permissions: ["CYS_RISK_INLAND_FLOOD_ISPRA"],
    permissions: [PermissionIdEnum.InlandFloodIspra],
    colorRange: ["#F7F7F7", "#CAE9FA", "#106FFE", "#042575"],
    description: i18n.t("riskExposureMapExplained.inlandFloodIspra"),
    label: `${i18n.t("riskAssessment.inlandFloodIspra")} (ITA)`,
    pages: [PolicyDetails, LocationRiskAssessment],
  },
  {
    cysId: HazardIdEnum.SeismicRiskGemGlobal,
    name: "Seismic Risk Gem Global",
    // permissions: ["CYS_RISK_SEISMIC_GEM_WRL"],
    permissions: [PermissionIdEnum.SeismicRiskGemGlobal],
    colorRange: gemSeismicColors,
    description: "Seismic Risk Gem Global",
    label: "Seismic Risk GEM (Global)",
    pages: [PolicyDetails, LocationRiskAssessment],
  },
];
